import React, { type ReactNode } from 'react';

import { ColumnsWrapper, PrimaryWrapper, SecondaryWrapper } from './styles';

export interface ColumnsProps {
    children: ReactNode;
    stretch?: boolean;
}

export interface CommonColumnProps {
    children: ReactNode;
    padded?: boolean;
    scrollable?: boolean;
}

export function Columns({ children, stretch = false }: ColumnsProps) {
    return <ColumnsWrapper $stretch={stretch}>{children}</ColumnsWrapper>;
}

export function Primary({ children, padded = false, scrollable = false }: CommonColumnProps) {
    return (
        <PrimaryWrapper $padded={padded} $scrollable={scrollable}>
            {children}
        </PrimaryWrapper>
    );
}

export function Secondary({ children, padded = false, scrollable = false }: CommonColumnProps) {
    return (
        <SecondaryWrapper $padded={padded} $scrollable={scrollable}>
            {children}
        </SecondaryWrapper>
    );
}

Columns.Primary = Primary;
Columns.Secondary = Secondary;
